// The icon motifs in ALPHABETICAL ORDER
export enum IconMotif {
  Alternatives = 'alternatives',
  Bike = 'bike',
  Bus = 'bus',
  BussOnDemand = 'bussOnDemand',
  Calendar = 'calendar',
  CalendarWithArrow = 'calendarWithArrow',
  Car = 'car',
  Exclamation = 'exclamation',
  Ferry = 'ferry',
  Info = 'info',
  Taxi = 'taxi',
  Train = 'train',
  Tram = 'tram',
  Walk = 'walk',
}
